<div class="container">
  <div class="navigation">
    <b>Params: </b>
    <a (click)="navigate('params')">folders/:folderId/mails/:mailId</a>
    <br />
    <b>Matrix Params: </b>
    <a (click)="navigate('matrixParams')"
      >folders/:folderId/mails/:mailId;fullView=true</a
    >
    <br />
    <b>Query Params: </b>
    <a (click)="navigate('queryParams')"
      >?search=ss-ngrx-store-router?type=angular-library</a
    >
    <br />
    <b>Fragment: </b>
    <a (click)="navigate('fragment')">#popup</a>
    <br />
    <b>Data: </b>
    <a (click)="navigate('data')">route-with-static-data</a>
  </div>
  <p>
    Feel free to experiment in the address bar.. Or,
    <a
      href="https://stackblitz.com/edit/ss-ngrx-router-store?file=src/app/routing.module.ts"
      target="_blank"
      rel="noopener"
      >edit routes on Stackblitz</a
    >..
  </p>
  <div class="state">
    <h3>SS Router State:</h3>
    <ss-ngrx-router-store-state></ss-ngrx-router-store-state>
    <p>
      This demo is running in dev environment. You can inspect Actions and State
      in the browser console as well as Redux DevTools.
    </p>
  </div>
</div>

<router-outlet></router-outlet>
